import { render, staticRenderFns } from "./CatalogoVirtualTable.vue?vue&type=template&id=0788b580&scoped=true&"
import script from "./CatalogoVirtualTable.vue?vue&type=script&lang=js&"
export * from "./CatalogoVirtualTable.vue?vue&type=script&lang=js&"
import style0 from "./CatalogoVirtualTable.vue?vue&type=style&index=0&id=0788b580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788b580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
